
import { useContext, useEffect, useState } from 'react';
import AdminSideBar from '../../components/adminSideBar/AdminSideBar';
import LoadingComponent from '../../components/loadingComponent/LoadingComponent';
import TableComponent from '../../components/tableComponent/TableComponent';
import './delivery.css';
import { DeliveryContext } from '../../context/deliveryContext/DeliveryContext';
import { getDeliveries, addDelivery, updateDelivery, ToggleActiveDelivery } from '../../context/deliveryContext/apiCalls';
import ErrorComponent from '../../components/errorComponent/ErrorComponent';
import { useParams, useNavigate } from 'react-router-dom';
import PaginationComponent from '../../components/paginationComponent/PaginationComponent';
import PageSizeComponent from '../../components/pageSizeComponent/PageSizeComponent';
import DropDownComponent from '../../components/dropDownComponent/DropDownComponent';
import { wilayas, communes, typeLivs } from '../../data.js';
import FilterInput from '../../components/filterInput/FilterInput.jsx';
import ModalComponent from '../../components/modalComponent/ModalComponent.jsx';
import FormInput from '../../components/formInput/FormInput.jsx';
import SubLoadingComponent from '../../components/subLoadingComponent/SubLoadingComponent.jsx';
import { AgenceContext } from '../../context/agenceContext/AgenceContext.js';
import { getAgencesByWilaya } from '../../context/agenceContext/apiCalls.js';
import { AuthContext } from '../../context/authContext/AuthContext.js';

function Delivery() {
    const { deliveries, dispatch, isFetching, error, delivery, isFetchingAdd, errorAdd, isFetchingUpdate, errorUpdate, isFetchingActivate, errorActivate, count: pages } = useContext(DeliveryContext);
    const [type, setType] = useState(typeLivs[0]);
    const [agence, setAgence] = useState({ nom: "Choisir Agence", id: 0, });
    const [username, setUsername] = useState("");
    const [wilaya, setWilaya] = useState(wilayas[0]);
    const [nom, setNom] = useState("");
    const [vehnom, setvehnom] = useState("");
    const [vehmat, setVehmat] = useState("");

    const { dispatch: dispatchAgence, agencesByWilaya } = useContext(AgenceContext);
    const { user } = useContext(AuthContext);

    const { page = 1 } = useParams();
    const navigate = useNavigate();
    const [pageSize, setPageSize] = useState(10);

    useEffect(() => {
        getAgencesByWilaya(dispatchAgence);
    }, [])
    useEffect(() => {
        getDeliveries(dispatch, pageSize, page, type.id, agence.id, username, wilaya.id, nom, vehnom, vehmat);
    }, [dispatch, page, pageSize, type, agence, username, wilaya, nom, vehnom, vehmat])

    useEffect(() => {
        navigate(`/deliveries/1`);
    }, [type, agence, username, wilaya, nom, vehnom, vehmat])


    /**************  Ajouter Modal  **************/
    const [modalAddActive, setModalAddActive] = useState(false);
    const [addType, setAddType] = useState(typeLivs[0]);
    const [addAgence, setAddAgence] = useState({ nom: 'Choisir Agence', id: 0 });
    const [addUsername, setAddUsername] = useState("");
    const [addPassword, setAddPassword] = useState("");
    const [addErrorBox, setAddErrorBox] = useState("");
    const [addWilaya, setAddWilaya] = useState(wilayas[0]);
    const [addCommune, setAddCommune] = useState(communes[0][0]);
    const [addNom, setAddNom] = useState("");
    const [addPrenom, setAddPrenom] = useState("");
    const [addEmail, setAddEmail] = useState("");
    const [addTel1, setAddTel1] = useState("");
    const [addTel2, setAddTel2] = useState("");
    const [addVehnom, setAddVehnom] = useState("");
    const [addVehmat, setAddVehmat] = useState("");

    useEffect(() => {
        setAddCommune(communes[addWilaya.id][0]);
    }, [addWilaya])

    useEffect(() => {
        if (Object.keys(delivery).length !== 0) {
            getDeliveries(dispatch, pageSize, page, type.id, agence.id, username, wilaya.id, nom, vehnom, vehmat);
            setAddType(typeLivs[0]);
            setAddUsername('');
            setAddPassword('');
            setAddWilaya(wilayas[0]);
            setAddCommune(communes[0][0]);
            setAddNom('');
            setAddPrenom('');
            setAddEmail('');
            setAddTel1('');
            setAddTel2('');
            setAddVehnom('');
            setAddVehmat('');
            setModalAddActive(false);
            setAddErrorBox("");
        }
    }, [delivery])

    useEffect(() => {
        if (errorAdd != false) {
            setAddErrorBox(errorAdd);
            setModalAddActive(true);
        }
    }, [errorAdd])

    const handleAddDelivery = () => {
        if (addType.id === 0) {
            setAddErrorBox('Vous devez définir le Type');
            return;
        }
        if (addType.id === 7 && addAgence.id === 0) {
            setAddErrorBox('Vous devez attribuer ce livreur a une agence');
            return;
        }
        if (addUsername.trim() == "") {
            setAddErrorBox('Vous devez compléter le Username');
            return;
        }
        if (addPassword.trim() == "") {
            setAddErrorBox('Vous devez compléter le Passsword');
            return;
        }
        if (addWilaya.id === 0) {
            setAddErrorBox('Vous devez compléter la Wilaya');
            return;
        }
        if (addCommune.id === 0) {
            setAddErrorBox('Vous devez compléter la Commune');
            return;
        }
        if (addNom.trim() == "") {
            setAddErrorBox('Vous devez compléter le Nom');
            return;
        }
        if (addTel1.trim() == "") {
            setAddErrorBox('Vous devez compléter Tel1');
            return;
        }
        if (addVehnom.trim() == "") {
            setAddErrorBox('Vous devez compléter Nom de Vehicule');
            return;
        }
        if (addVehmat.trim() == "") {
            setAddErrorBox('Vous devez compléter Matricule de Vehicule');
            return;
        }
        addDelivery(dispatch, addType.id, addType.id === 7 ? addAgence.id : null, addUsername, addPassword, addWilaya.id, addCommune.id, addNom, addPrenom, addEmail, addTel1, addTel2, addVehnom, addVehmat);
    }

    /**************  End Ajouter Modal  **************/

    /**************  Update Modal  **************/
    const [modalUpdateActive, setModalUpdateActive] = useState(false);
    const [updateId, setUpdateId] = useState("");
    const [updateType, setUpdateType] = useState(typeLivs[0]);
    const [updateAgence, setUpdateAgence] = useState({ nom: 'Choisir Agence', id: 0 });
    const [updateUsername, setUpdateUsername] = useState("");
    const [updatePassword, setUpdatePassword] = useState("");
    const [updateErrorBox, setUpdateErrorBox] = useState("");
    const [updateWilaya, setUpdateWilaya] = useState(wilayas[0]);
    const [updateCommune, setUpdateCommune] = useState(communes[0][0]);
    const [updateNom, setUpdateNom] = useState("");
    const [updatePrenom, setUpdatePrenom] = useState("");
    const [updateEmail, setUpdateEmail] = useState("");
    const [updateTel1, setUpdateTel1] = useState("");
    const [updateTel2, setUpdateTel2] = useState("");
    const [updateVehnom, setUpdateVehnom] = useState("");
    const [updateVehmat, setUpdateVehmat] = useState("");

    const updateModalUpdateActive = (id, type, aagence, username, wilayaa, communee, nom, prenom, email, tel1, tel2, vehnom, vehmat) => {
        setModalUpdateActive(true);
        setUpdateId(id);
        setUpdateType(typeLivs.filter(item => item.id === type)[0]);
        aagence ? setUpdateAgence(agencesByWilaya.filter(item => item.id === aagence)[0]) : setUpdateAgence({ nom: 'Choisir Agence', id: 0 });
        setUpdateUsername(username);
        setUpdateWilaya(wilayas.filter(item => item.id === wilayaa)[0]);
        setUpdateCommune(communes[wilayaa].filter(item => item.id === communee)[0]);
        setUpdateNom(nom);
        setUpdatePrenom(prenom);
        setUpdateEmail(email);
        setUpdateTel1(tel1);
        setUpdateTel2(tel2 || "");
        setUpdateVehnom(vehnom || "");
        setUpdateVehmat(vehmat || "");
    }

    useEffect(() => {
        if (Object.keys(delivery).length !== 0) {
            getDeliveries(dispatch, pageSize, page, type.id, agence.id, username, wilaya.id, nom, vehnom, vehmat);
            setUpdateType(typeLivs[0]);
            setUpdateAgence({ nom: 'Choisir Agence', id: 0 });
            setUpdateUsername('');
            setUpdatePassword('');
            setUpdateWilaya(wilayas[0]);
            setUpdateCommune(communes[0][0]);
            setUpdateNom('');
            setUpdatePrenom('');
            setUpdateEmail('');
            setUpdateTel1('');
            setUpdateTel2('');
            setUpdateVehnom("");
            setUpdateVehmat("");
            setModalUpdateActive(false);
            setUpdateErrorBox("");
        }
    }, [delivery])

    useEffect(() => {
        if (errorUpdate != false) {
            setUpdateErrorBox(errorUpdate);
            setModalUpdateActive(true);
        }
    }, [errorUpdate])

    const handleUpdateDelivery = () => {
        if (updateType.id === 0) {
            setUpdateErrorBox('Vous devez définir le Type');
            return;
        }
        if (updateAgence.id === 0) {
            setUpdateErrorBox('Vous devez attribuer ce Liv/Trans a une agence');
            return;
        }
        if (updateUsername.trim() == "") {
            setUpdateErrorBox('Vous devez compléter le Username');
            return;
        }
        if (updateWilaya.id === 0) {
            setUpdateErrorBox('Vous devez compléter la Wilaya');
            return;
        }
        if (updateCommune.id === 0) {
            setUpdateErrorBox('Vous devez compléter la Commune');
            return;
        }
        if (updateNom.trim() == "") {
            setUpdateErrorBox('Vous devez compléter le Nom');
            return;
        }
        if (updateTel1.trim() == "") {
            setUpdateErrorBox('Vous devez compléter le Email');
            return;
        }
        if (updateVehnom.trim() == "") {
            setUpdateErrorBox('Vous devez compléter Nom de Vehicule');
            return;
        }
        if (updateVehmat.trim() == "") {
            setUpdateErrorBox('Vous devez compléter Matricule de Vehicule');
            return;
        }
        updateDelivery(dispatch, updateId, updateType.id, updateAgence.id, updateUsername, updatePassword, updateWilaya.id, updateCommune.id, updateNom, updatePrenom, updateEmail, updateTel1, updateTel2, updateVehnom, updateVehmat);
    }

    /**************  End Update Modal  **************/

    const toggleActive = (deliveryId) => {
        ToggleActiveDelivery(dispatch, deliveryId);
    }

    return (
        <div className='container-global'>
            <AdminSideBar activeTab="delivery" />
            <div className='center'>
                <div className="title">
                    <span className="material-symbols-rounded">shoppingmode</span>
                    <span>Livreurs et Transporteurs</span>
                </div>


                {
                    error ? <ErrorComponent error={error} /> : (
                        <>
                            <div className="filter">
                                <span className="adv-research">Recherche Avancée</span>
                                <div className="filter-content">
                                    <DropDownComponent data={typeLivs} itemChoisir={type} setItemChoisir={setType} filter />
                                    <FilterInput placeholder={"Username"} setItem={setUsername} />
                                    {
                                        user.role && (
                                            (user.role === 1 || user.role === 2) && (
                                                <>
                                                    <DropDownComponent data={wilayas} itemChoisir={wilaya} setItemChoisir={setWilaya} filter />
                                                    <DropDownComponent data={[{ nom: "Choisir Agence", id: 0, }, ...agencesByWilaya]} itemChoisir={agence} setItemChoisir={setAgence} filter />
                                                </>
                                            )
                                        )
                                    }
                                    <FilterInput placeholder={"Nom"} setItem={setNom} />
                                    <FilterInput placeholder={"Veh Nom"} setItem={setvehnom} />
                                    <FilterInput placeholder={"Veh Mat"} setItem={setVehmat} />
                                </div>
                            </div>

                            {
                                user.role && (
                                    (user.role === 1 || user.role === 2) && (
                                        <div className="add-item">
                                            <span className='color-1' onClick={() => setModalAddActive(true)}>Ajouter</span>
                                        </div>
                                    )
                                )
                            }

                            {
                                isFetching ? <LoadingComponent /> : (
                                    deliveries.length === 0 ? <span className='no-data'>Il n'y a pas encore de données</span>
                                        : (
                                            <>
                                                <PageSizeComponent pageSize={pageSize} setPageSize={setPageSize} itemLocation='deliveries' />
                                                <div className="content">
                                                    {
                                                        <>
                                                            <TableComponent headers={user.role && (user.role === 1 || user.role === 2)
                                                                ? ['Id', 'type', 'Agence', 'username', 'Wilaya', 'Commune', 'Nom', 'Date', 'Action']
                                                                : ['Id', 'type', 'Agence', 'username', 'Wilaya', 'Commune', 'Nom', 'Date']
                                                            }>
                                                                {
                                                                    deliveries.map((delivery, index) => (
                                                                        // <tr key={index} style={delivery.active == 0 ? { background: 'rgba(248, 103, 0, 0.2)' } : {}}>
                                                                        <tr key={index}>
                                                                            <td>{delivery.id}</td>
                                                                            <td>{delivery.RoleId === 7 ? "Livreur" : "Transporteur"}</td>
                                                                            <td>{delivery.Agence ? delivery.Agence.nom : ""}</td>
                                                                            <td>{delivery.username}</td>
                                                                            <td>{wilayas.filter(item => item.id == delivery.Userinfo.wilaya)[0]['nom']}</td>
                                                                            <td>{communes[delivery.Userinfo.wilaya].filter(item => item.id == delivery.Userinfo.commune)[0]['nom']}</td>
                                                                            <td>{delivery.Userinfo.nom}</td>
                                                                            <td>{delivery.createdAt.slice(0, 10)}</td>
                                                                            {
                                                                                user.role && (
                                                                                    (user.role === 1 || user.role === 2) && (
                                                                                        <td>
                                                                                            <span className='update' onClick={() => updateModalUpdateActive(delivery.id, delivery.RoleId, delivery.Agence ? delivery.Agence.id : null, delivery.username, delivery.Userinfo.wilaya, delivery.Userinfo.commune, delivery.Userinfo.nom, delivery.Userinfo.prenom, delivery.Userinfo.email, delivery.Userinfo.tel1, delivery.Userinfo.tel2 || "", delivery.Userinfo.vehNom, delivery.Userinfo.vehMat)}>Modifier</span>
                                                                                            <span className='detail' onClick={() => toggleActive(delivery.id)} style={isFetchingActivate ? { cursor: 'not-allowed', pointerEvents: 'none' } : {}}>
                                                                                                {
                                                                                                    isFetchingActivate ? (
                                                                                                        delivery.active == 0 ? "Activer..." : "Disactiver..."
                                                                                                    ) : (
                                                                                                        delivery.active == 0 ? "Activer" : "Disactiver"
                                                                                                    )
                                                                                                }
                                                                                            </span>
                                                                                        </td>
                                                                                    )
                                                                                )
                                                                            }
                                                                        </tr>
                                                                    ))
                                                                }
                                                            </TableComponent>
                                                            {
                                                                (pages > 1) && (<PaginationComponent page={page} pages={pages} item='deliveries' />)
                                                            }
                                                        </>
                                                    }
                                                </div>
                                            </>
                                        )
                                )
                            }
                        </>
                    )
                }

            </div>

            {/*  Modal Components */}
            {
                <>
                    <ModalComponent modalActive={modalAddActive} setModalActive={setModalAddActive} setErrorBox={setAddErrorBox} title="Ajouter Liv/Tran">
                        {
                            isFetchingAdd ? <SubLoadingComponent /> : (
                                <form>
                                    {addErrorBox !== "" && (<div className='box-error'>{addErrorBox}</div>)}
                                    <div className='side-to-side'>
                                        <DropDownComponent data={typeLivs} itemChoisir={addType} setItemChoisir={setAddType} />
                                        {
                                            addType.id === 7 && (
                                                <DropDownComponent data={[{ nom: "Choisir Agence", id: 0, }, ...agencesByWilaya]} itemChoisir={addAgence} setItemChoisir={setAddAgence} filter />
                                            )
                                        }
                                    </div>
                                    <div className='side-to-side'>
                                        <FormInput label='Username *' itemInput={addUsername} setItemInput={setAddUsername} auth />
                                        <FormInput label='Password *' itemInput={addPassword} setItemInput={setAddPassword} auth />
                                    </div>
                                    <div className='side-to-side'>
                                        <DropDownComponent data={wilayas} itemChoisir={addWilaya} setItemChoisir={setAddWilaya} />
                                        <DropDownComponent data={communes[addWilaya.id]} itemChoisir={addCommune} setItemChoisir={setAddCommune} />
                                    </div>
                                    <div className='side-to-side'>
                                        <FormInput label='Nom *' itemInput={addNom} setItemInput={setAddNom} auth />
                                        <FormInput label='Email' itemInput={addEmail} setItemInput={setAddEmail} auth />
                                    </div>
                                    <div className='side-to-side'>
                                        <FormInput label='Tel1 *' itemInput={addTel1} setItemInput={setAddTel1} auth istype='number' />
                                        <FormInput label='Tel2' itemInput={addTel2} setItemInput={setAddTel2} auth istype='number' />
                                    </div>
                                    <div className='side-to-side'>
                                        <FormInput label='Veh Nom *' itemInput={addVehnom} setItemInput={setAddVehnom} auth />
                                        <FormInput label='Veh Mat *' itemInput={addVehmat} setItemInput={setAddVehmat} auth />
                                    </div>
                                    <div className='button' onClick={handleAddDelivery}>
                                        <span>Valider</span>
                                    </div>
                                </form>
                            )
                        }
                    </ModalComponent>

                    <ModalComponent modalActive={modalUpdateActive} setModalActive={setModalUpdateActive} setErrorBox={setUpdateErrorBox} title="Modifier Liv/Tran">
                        {
                            isFetchingUpdate ? <SubLoadingComponent /> : (
                                <form>
                                    {updateErrorBox !== "" && (<div className='box-error'>{updateErrorBox}</div>)}
                                    <div className='side-to-side'>
                                        <DropDownComponent data={typeLivs} itemChoisir={updateType} setItemChoisir={setUpdateType} />
                                        <DropDownComponent data={[{ nom: "Choisir Agence", id: 0, }, ...agencesByWilaya]} itemChoisir={updateAgence} setItemChoisir={setUpdateAgence} filter />
                                    </div>
                                    <div className='side-to-side'>
                                        <FormInput label='Username *' itemInput={updateUsername} setItemInput={setUpdateUsername} auth />
                                        <FormInput label='Password' itemInput={updatePassword} setItemInput={setUpdatePassword} auth />
                                    </div>
                                    <div className='side-to-side'>
                                        <DropDownComponent data={wilayas} itemChoisir={updateWilaya} setItemChoisir={setUpdateWilaya} />
                                        <DropDownComponent data={communes[updateWilaya.id]} itemChoisir={updateCommune} setItemChoisir={setUpdateCommune} />
                                    </div>
                                    <div className='side-to-side'>
                                        <FormInput label='Nom *' itemInput={updateNom} setItemInput={setUpdateNom} auth />
                                        <FormInput label='Email' itemInput={updateEmail} setItemInput={setUpdateEmail} auth />
                                    </div>
                                    <div className='side-to-side'>
                                        <FormInput label='Tel1 *' itemInput={updateTel1} setItemInput={setUpdateTel1} auth istype='number' />
                                        <FormInput label='Tel2' itemInput={updateTel2} setItemInput={setUpdateTel2} auth istype='number' />
                                    </div>
                                    <div className='side-to-side'>
                                        <FormInput label='Veh Nom *' itemInput={updateVehnom} setItemInput={setUpdateVehnom} auth />
                                        <FormInput label='Veh Mat *' itemInput={updateVehmat} setItemInput={setUpdateVehmat} auth />
                                    </div>
                                    <div className='button' onClick={handleUpdateDelivery}>
                                        <span>Valider</span>
                                    </div>
                                </form>
                            )
                        }
                    </ModalComponent>
                </>
            }
            {/*  End Modal Components */}

        </div>
    )
}

export default Delivery
